import { Box, Grid, Skeleton } from "@mui/material";
import PropTypes from "prop-types";

type SelectorComponent = {
	textWidth: number;
	selectorWidth: number;
	widthBtn?: boolean;
};
function SelectorComponent({ textWidth, selectorWidth, widthBtn = false }: SelectorComponent) {
	return (
		<Grid item>
			<Skeleton
				sx={{
					borderRadius: "6px",
				}}
				variant="rectangular"
				width={textWidth}
				height={20}
			/>

			<Box
				sx={{
					display: "flex",
					alignItems: "center",
					columnGap: 2,
				}}
			>
				<Skeleton
					sx={{
						marginTop: "8px",
						borderRadius: "6px",
					}}
					variant="rectangular"
					width={selectorWidth}
					height={30}
				/>
				{widthBtn && (
					<>
						<Skeleton
							sx={{
								marginTop: "8px",
								borderRadius: "20px",
							}}
							variant="rectangular"
							width={50}
							height={24}
						/>
						<Skeleton
							sx={{
								marginTop: "8px",
								borderRadius: "6px",
							}}
							variant="rectangular"
							width={100}
							height={18}
						/>
					</>
				)}
			</Box>
		</Grid>
	);
}

SelectorComponent.propTypes = {
	textWidth: PropTypes.number,
	selectorWidth: PropTypes.number,
	widthBtn: PropTypes.bool,
};

export default function AdministrationToolsLoader() {
	return (
		<>
			<Grid container direction="column" pl={"20px"}>
				<Skeleton
					sx={{
						borderRadius: "6px",
						marginTop: 1,
					}}
					variant="rectangular"
					width={380}
					height={30}
				/>
				<SelectorComponent textWidth={0} selectorWidth={240} />
				<Skeleton
					sx={{
						marginTop: 5.5,
						borderRadius: "6px",
					}}
					variant="rectangular"
					width={300}
					height={30}
				/>
				<SelectorComponent textWidth={0} selectorWidth={240} />
			</Grid>

			<Grid container pt={3} pl={"20px"} spacing={4}>
				{Array.from({ length: 4 }).map((_, i) => (
					<SelectorComponent key={i} textWidth={200} selectorWidth={240} widthBtn />
				))}
			</Grid>
		</>
	);
}
